export class RoleRegistration {
  public id: string;
  public registrationId: string;
  public roleId: string;
  public name: string;
  public finalResultIssued: boolean = false;
}
